export const enum DeviceTypes{
    MX600LVRU = "MX600LVRU"//"MX600LVRU" // Имеет дополнительные датчики освещенности и наклона 
}